<template>
  <el-dialog
    v-if="userInfo"
    :title="$t('upgradeAccount.title')"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="isOpenModalUpgradeAccount"
    :before-close="closeUpgradeAccount"
    class="dialog-confirm-upgrade"
  >
    <i18n path="upgradeAccount.description" tag="p">
      <b slot="trial">{{$t('upgradeAccount.trial')}}</b>
    </i18n>
    <i18n path="upgradeAccount.paymentHint" tag="p">
      <b slot="date" class="text-danger">{{endPlan}}</b>
    </i18n>
    <p>{{$t('upgradeAccount.notify')}}</p>
    <h3>{{$t('upgradeAccount.detail')}}</h3>
    <div class="table-content">
      <table class="mt-1" v-loading="callingAPI">
        <thead>
          <tr>
            <th>{{$t('upgradeAccount.table.info')}}</th>
            <th>{{$t('upgradeAccount.table.package')}}</th>
            <th>{{$t('upgradeAccount.table.startDate')}}</th>
            <th>{{$t('upgradeAccount.table.endDate')}}</th>
            <th class="text-right">{{$t('upgradeAccount.table.fee')}}</th>
          </tr>
        </thead>
        <tr v-for="item in listPackage" :key="item.index">
          <td>{{item.resource }}</td>
          <td>{{item.plan.price | numberWithDelimiter}} VNĐ/{{item.plan.interval_count}} {{item.plan.interval === 'month' ?'tháng' : ''}}</td>
          <td>{{moment(item.start).format('DD-MM-YYYY')}}</td>
          <td>{{moment(item.end).format('DD-MM-YYYY')}}</td>
          <td class="text-right">{{item.price.charge_this_month | numberWithDelimiter}} VNĐ</td>
        </tr>
        <tr class="text-right text-danger">
          <td colspan="5">
            <b>{{$t('upgradeAccount.table.total')}} : {{totalCharge | numberWithDelimiter}} VNĐ</b>
          </td>
        </tr>
      </table>
    </div>
    <span
      slot="footer"
      class="dialog-footer d-flex align-items-center justify-space-between mt-0-8"
    >
      <el-button size="small" type="info" @click="closeUpgradeAccount">{{$t('popup.cancel')}}</el-button>
      <el-button size="small" type="primary" class="w-25" :disabled="isUpradeAccount">
        <span
          v-if="checkValidUpgradeAccount"
          @click="handleUpgradeAccount"
        >{{$t('upgradeAccount.btnPayment')}}</span>
        <span v-else @click="gotoBilling">{{$t('upgradeAccount.btnPayIn')}}</span>
        <i class="el-icon-loading" v-if="isUpradeAccount"></i>
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
  import authService from '@/services/auth'
  import moment from 'moment'
  export default {
    name: 'modal-upgrade-account',
    props: ['userInfo', 'isOpenModalUpgradeAccount'],
    data () {
      return {
        isUpradeAccount: false,
        endPlan: moment().endOf('month').format('DD-MM-YYYY'),
        listPackage: [],
        totalCharge: 0,
        callingAPI: false
      }
    },
    watch: {},
    computed: {
      checkValidUpgradeAccount () {
        this.endPlan = moment(this.userInfo.trial.plan_to_upgrade).format('DD-MM-YYYY')
        if (this.userInfo.balance - this.userInfo.trial.amount_to_upgrade >= 0) {
          return true
        } else {
          return false
        }
      }
    },
    beforeMount () {
      this.loadData()
    },
    methods: {
      moment,

      loadData () {
        this.callingAPI = true
        authService.fetchTrial().then((response) => {
          this.listPackage = response.items
          this.totalCharge = response.total
          this.callingAPI = false
        }).catch(() => {
          this.callingAPI = false
        })
      },
      closeUpgradeAccount () {
        this.$emit('closeModalUpgradeAccount')
      },
      handleUpgradeAccount () {
        authService.upgradeAccount()
          .then(res => {
            authService.check()
            this.$emit('upgradeAccount', 'hideNotify')
            this.$emit('closeModalUpgradeAccount')
            this.$notify({
              message: res.message,
              showClose: false,
              duration: 3000,
              customClass: 'success'
            })
          })
          .catch((e) => {
            console.log(e)
            let msg = ''
            if (e.response.data && e.response.data.message) {
              msg = e.response.data.message
            }
            this.$notify({
              message: msg,
              showClose: false,
              duration: 3000,
              customClass: 'error'
            })
          })
      },
      gotoBilling () {
        this.$emit('closeModalUpgradeAccount')
        this.$router.push({
          name: 'billing.index',
          query: {amount: this.totalCharge, dialog: true}
        })
      }
    },
    mounted () {
    }
  }
</script>
<style lang="scss" scoped>
.dialog-confirm-upgrade {
  table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    tr {
      &:first-child {
        border-bottom: 1px solid #ebeef5;
      }
      &:hover {
        background-color: #f5f7fa;
      }
      th {
        padding: 12px 5px;
        &:nth-child(1) {
          width: 30%;
        }
        &:nth-child(2) {
          width: 25%;
        }
        &:nth-child(3) {
          width: 15%;
        }
        &:nth-child(4) {
          width: 15%;
        }
        &:nth-child() {
          width: 15%;
        }
      }
      td {
        padding: 12px 5px;
        &:last-child {
          text-align: right !important;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .dialog-confirm-upgrade {
    .el-dialog {
      table {
        width: 100%;
      }
    }
  }
}
@media only screen and (max-width: 480px) {
  .dialog-confirm-upgrade {
    .el-dialog {
      table {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/idc/components/upgrade-account.vue